import React from 'react';
import { Helmet } from 'react-helmet';
import LoginForm from 'containers/LoginForm';

function LoginPage({ location }) {
  return (
    <div className="expand-wrap">
      <Helmet>
        <title>Member Sign In</title>
      </Helmet>
      <LoginForm location={location} />
    </div>
  );
}

export default LoginPage;
